export default __webpack_public_path__ + "static/media/aws.5bcb4fa2.svg";